import { render, staticRenderFns } from "./GetOrderReport.vue?vue&type=template&id=64040804&scoped=true&"
import script from "./GetOrderReport.vue?vue&type=script&lang=js&"
export * from "./GetOrderReport.vue?vue&type=script&lang=js&"
import style0 from "./GetOrderReport.vue?vue&type=style&index=0&id=64040804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64040804",
  null
  
)

export default component.exports